export enum ETrackOptions {
    TECHNOLOGY = 'Technology',
    BUSINESS_CONSULTING = 'Business Consulting',
    SHARED_SERVICE = 'Shared Service',
    QUALITY_ASSURANCE = 'Quality Assurance',
    PROJECT_MANAGEMENT = 'Project Management'
  }
  